module.exports = ".card {\n  width: 100%; }\n\n.attach-proposal .custom-file {\n  overflow: hidden; }\n\n.attach-account .custom-file-control {\n  line-height: 28px; }\n\n.attach-proposal .custom-file-control:lang(en)::after {\n  content: '' !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/attachmentsender/component/attachmentsender/attachmentsender.component.scss
// module id = ./src/app/attachmentsender/component/attachmentsender/attachmentsender.component.scss
// module chunks = main